import r from"./_baseIsNative.js";import t from"./_getValue.js";function e(e,o){var a=t(e,o);return r(a)?a:void 0}export{e as default};
//# sourceMappingURL=_getNative.js.map
